import React from "react";
import DashboardNumeric from "./DashboardNumerics";
import LastTransactions from "./LastTransactions";
import DealsPerformance from "./DealsPerformance";
import ActiveDeals from "./ActiveDealsPrint";
import TotalIncome from "./TotalIncome";

const PdfPrint = ({
  startDate,
  endDate,
  comparisonStartDate,
  comparisonEndDate,
  diffDay,
  setDiffDay,
}) => {
  return (
    <div
      id="pdf_print"
      style={{ background: "#f5f6fa", padding: "3%", height: "1585px" }}
    >
      <div
        className="dashboard-title"
        style={{
          width: "100%",
          marginBottom: "30px",
        }}
      >
        <h1
          style={{
            fontWeight: 600,
            fontSize: "30px",
            lineHeight: "36px",
            margin: "0px",
          }}
        >
          Dashboard
        </h1>
      </div>
      <div
        style={{
          // width: "100%",
          background: "white",
          // height: "120px",
          maxHeight: "120px",
          padding: "2%",
        }}
      >
        <DashboardNumeric
          startDate={startDate}
          endDate={endDate}
          comparisonStartDate={comparisonStartDate}
          comparisonEndDate={comparisonEndDate}
          isPrint={true}
        />
      </div>

      <div style={{ width: "100%", marginTop: "4%" }}>
        <div className="dashboard-row">
          <div
            style={{
              // width: "60%",
              background: "white",
              display: "inline-block",
              // marginLeft: "1%",
              // marginTop: "3%",
              height: "440px",
              // maxHeight: "440px",
            }}
          >
            <div
              className="dashboard-col-left"
              style={{
                width: "595px",
                padding: "4%",
              }}
            >
              <TotalIncome
                diffDay={diffDay}
                setDiffDay={setDiffDay}
                startDate={startDate}
                endDate={endDate}
                isPrint={true}
              />
            </div>
          </div>
          <div
            style={{
              width: "38%",
              background: "white",
              display: "inline-block",
              marginLeft: "3%",
              position: "absolute",
              // marginTop: "3%",
              maxHeight: "440px",
            }}
          >
            <div className="dashboard-col-right">
              <LastTransactions isPrint={true} />
            </div>
          </div>
        </div>
      </div>

      <div className="dahsboard-second-row" style={{ marginTop: "5%" }}>
        <div
          style={{
            // width: "30%",
            height: "410px",
            // maxHeight: "410px",
            display: "inline-block",
            position: "absolute",
          }}
        >
          <div className="col-left-1">
            {" "}
            <DealsPerformance isPrint={true} />
          </div>
        </div>
        <div
          style={{
            // width: "50%",
            height: "440px",
            // maxHeight: "440px",
            background: "white",
            display: "inline-block",
            marginLeft: "46%",
            position: "absolute",
          }}
        >
          <div className="col-right-1">
            <ActiveDeals />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PdfPrint;
